import $ from "jquery";

$(function () {
  $('#overlay-close, .overlay__bg').on('click', function () {
    $('.overlay__bg').hide();
    return false;
  });
  $('.overlay__content').on('click', function () {
    return false;
  });
  $('.L--header_register').on('click', function () {
    $('.overlay__bg').show();
    return false;
  });
  $('.kantan_btn').on('click', function () {
    $('.overlay__bg').show();
    return false;
  });
});